/******/ (() => { // webpackBootstrap
/*!**********************************************************!*\
  !*** ./zrc/scripts/layouts/information-blocks-banner.js ***!
  \**********************************************************/
class InformationBlocksBanner extends window.HTMLElement {
  constructor() {
    super();
    this.container = this;
    this.setCssVariableViewportRealHeight();
  }
  setCssVariableViewportRealHeight() {
    var generalMaxHeight = 0;
    $('.information-block-title').each(function () {
      generalMaxHeight = Math.max(generalMaxHeight, $(this).height());
    }).css('height', generalMaxHeight);

    // [(+)] ++++++++ LAS LÍNEAS DE CÓDIGO SIGUIENTES SE CONSERVARÁN PARA MEJORAR EL CÓDIGO ANTERIOR
    // PERO MIENTRAS SE MANTIENE ASÍ POR CUESTIONES DE TIEMPO. ++++++++ [(+)]

    // const blockTitle = document.querySelector('.information-block-title');

    // // eslint-disable-next-line no-undef
    // const titleObserver = new ResizeObserver((titles) => {
    //   for (const title of titles) {
    //     const cr = title.cr.height;

    //     title.style.height = cr;
    //   }
    // });

    // titleObserver.observe(blockTitle);
  }
}
if (window.customElements.get('information-blocks-banner') == null) {
  window.customElements.define('information-blocks-banner', InformationBlocksBanner);
}
/******/ })()
;